import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../api/axios';
import ReactMarkdown from 'react-markdown';

const AGB = ({ slug = 'agb' }) => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchContent();
    // eslint-disable-next-line
  }, [slug]);

  const fetchContent = async () => {
    try {
      const response = await axiosInstance.get(`/legal/${slug}`);
      setContent(response.data.content || '');
    } catch (error) {
      console.error('Error fetching AGB:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen py-12" style={{ backgroundColor: '#E8E0D5' }}>
        <div className="max-w-4xl mx-auto px-4">
          <p className="text-center">Lädt...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen py-12" style={{ backgroundColor: '#E8E0D5' }} data-testid={`legal-page-${slug}`}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-md p-8">
          <div className="prose prose-gray max-w-none">
            {content.trim().startsWith('<') ? (
              <div className="legal-html" dangerouslySetInnerHTML={{ __html: content }} />
            ) : (
            <ReactMarkdown
              components={{
                h1: ({node, ...props}) => <h1 className="text-3xl font-bold mb-6" style={{ color: '#6D5A47' }} {...props} />,
                h2: ({node, ...props}) => <h2 className="text-2xl font-semibold mb-4 mt-6" style={{ color: '#8B7355' }} {...props} />,
                h3: ({node, ...props}) => <h3 className="text-xl font-semibold mb-3 mt-4" style={{ color: '#8B7355' }} {...props} />,
                h4: ({node, ...props}) => <h4 className="text-base font-semibold mb-2 mt-3" style={{ color: '#8B7355' }} {...props} />,
                p: ({node, ...props}) => <p className="mb-3 text-gray-700" {...props} />,
                a: ({node, ...props}) => <a className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer" {...props} />,
                ul: ({node, ...props}) => <ul className="list-disc pl-6 mb-3" {...props} />,
                ol: ({node, ...props}) => <ol className="list-decimal pl-6 mb-3" {...props} />,
                strong: ({node, ...props}) => <strong className="font-semibold" {...props} />,
              }}
            >
              {content}
            </ReactMarkdown>
            )}
          </div>

          <div className="mt-8 pt-6 border-t">
            <Link
              to="/"
              className="inline-flex items-center text-blue-600 hover:underline"
              data-testid="agb-back-home-link"
            >
              ← Zurück zur Startseite
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AGB;
